import { Tenant }           from '@app/modules/admin-tenant/models/tenant.model';
import { AdminTenantState } from '@app/modules/admin-tenant/store/admin-tenant.state';
import { adapterSelectors } from '@core/store/adapter/adapter.selectors';
import { apiSelectors }     from '@core/store/api/api.selectors';
import { EntityAdapter }    from '@ngrx/entity';
import {
	createFeatureSelector,
	createSelector
}                           from '@ngrx/store';
import { LoggerService }    from '@shared/services/logger.service';

export function adminTenantSelector(
	adapter: EntityAdapter<Tenant>,
	storeId: string,
	logger: LoggerService
) {
	const adminStateSelector = createFeatureSelector<AdminTenantState>( storeId );
	const adapterSelector = { ...adapterSelectors<Tenant, AdminTenantState>( adapter, adminStateSelector ) };

	return {
		adapterSelector,
		...apiSelectors<Tenant, AdminTenantState>( adapter, adapterSelector ),


		// TENANT SPECIFIC SELECTORS
		selectTenantsEventCreateState: createSelector(
			adminStateSelector,
			( state: AdminTenantState ) => state.entityActions.create
		),
		selectTenantsChildren: ( parentTenantId: string ) =>
			createSelector(
				adapterSelector.all,
				( tenantList: Tenant[] ) =>
					tenantList.filter( tenant => tenant.parentTenantId === parentTenantId )
			)
	};
}
